import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    seasons: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 132,
        gap: 14,
        overflowX: 'auto',
        padding: '4px 4px 10px',
        [theme.breakpoints.down('sm')]: {
            gridAutoColumns: 112,
        },
    },
    season: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: 0,
        border: 0,
        background: 'none',
        font: 'inherit',
        color: theme.palette.text.primary,
        textAlign: 'left',
        cursor: 'pointer',
        '&:hover $seasonPoster': {
            transform: 'translateY(-3px)',
        },
    },
    seasonActive: {
        '& $seasonPoster': {
            outlineColor: theme.palette.primary.main,
        },
    },
    seasonPoster: {
        width: '100%',
        aspectRatio: '2 / 3',
        objectFit: 'cover',
        borderRadius: 10,
        background: theme.palette.raised,
        outline: '2px solid transparent',
        outlineOffset: 3,
        transition: 'outline-color 0.2s, transform 0.2s',
    },
    seasonName: {
        fontSize: 14,
        lineHeight: 1.3,
    },
    seasonMeta: {
        marginTop: -4,
        fontFamily: theme.fonts.mono,
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    episodes: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 'min(280px, 80%)',
        gap: 16,
        overflowX: 'auto',
        margin: 0,
        padding: '4px 4px 10px',
        listStyle: 'none',
        position: 'relative',
    },
    episode: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        minWidth: 0,
        padding: 8,
        borderRadius: 14,
        '&:hover': {
            background: theme.palette.raised,
        },
    },
    episodeCurrent: {
        background: alpha(theme.palette.primary.main, 0.1),
        boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.primary.main, 0.4)}`,
    },
    episodeUpcoming: {
        '& $still, & $text': {
            opacity: 0.6,
        },
    },
    still: {
        position: 'relative',
        aspectRatio: '16 / 9',
        maxWidth: '100%',
        borderRadius: 10,
        overflow: 'hidden',
        background: theme.palette.raised,
        '& img': {
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
    },
    play: {
        position: 'absolute',
        inset: 0,
        margin: 'auto',
        width: 44,
        height: 44,
        display: 'grid',
        placeItems: 'center',
        padding: 0,
        border: 0,
        borderRadius: '50%',
        cursor: 'pointer',
        color: '#fff',
        background: 'rgba(10, 10, 14, 0.78)',
        transition: 'background 0.2s, transform 0.2s',
        '&:hover': {
            background: theme.palette.primary.main,
            transform: 'scale(1.08)',
        },
    },
    code: {
        position: 'absolute',
        top: 8,
        left: 8,
        padding: '2px 7px',
        borderRadius: 6,
        background: 'rgba(10, 10, 14, 0.78)',
        color: '#fff',
        fontFamily: theme.fonts.mono,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.06em',
    },
    runtime: {
        position: 'absolute',
        right: 8,
        bottom: 8,
        padding: '1px 6px',
        borderRadius: 4,
        background: 'rgba(10, 10, 14, 0.78)',
        color: '#fff',
        fontFamily: theme.fonts.mono,
        fontSize: 11,
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 0,
        padding: '0 2px',
    },
    title: {
        fontSize: 15,
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    meta: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 10,
        fontFamily: theme.fonts.mono,
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    rating: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        color: theme.palette.text.primary,
        '& svg': {
            fontSize: 13,
            color: theme.palette.gold,
        },
    },
    now: {
        color: theme.palette.accent,
    },
    airs: {
        padding: '2px 7px',
        borderRadius: 6,
        border: '1px solid currentColor',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        fontSize: 11,
        color: theme.palette.success.main,
    },
    overview: {
        fontSize: 13,
        lineHeight: 1.5,
        color: theme.palette.text.secondary,
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
}));
